import * as React from "react";
import useLocalStorage from "../../../hooks/useLocalstorage";
import config from "../../../config";
import { useSelector } from "react-redux";
import { useBilling } from "../billingProvider";

const DraftContext = React.createContext();

const DraftProvider = ({ children, ...props }) => {
  const [draftBill, setDraftBill] = useLocalStorage("kotdraftBill", []);
  const [draftBillCatch, setDraftBillCatch] = useLocalStorage(
    "billingDraftCatch",
    []
  );
  const value = [draftBill, setDraftBill, draftBillCatch, setDraftBillCatch];
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const productList = useSelector((state) => state.products.productList);
  const employeeId = useSelector((state) => state.shopDetails.empId);

  const { getTaxableValueAndTaxs } = useBilling();
  React.useEffect(() => {
    (async function (shopId) {
      const getDraft = async () => {
        try {
          const payload = {
            action: "restaurant-get",
            shopId: shopId,
            employeeId: employeeId ? employeeId : "",
          };

          const res = await fetch(`${config.newApiGateway}/draft/draft`, {
            method: "POST",
            body: JSON.stringify({
              action: "getDraft",
              shopId: shopId,
              employeeId: employeeId ? employeeId : "",
              shopTypeandCustomertype: "restaurant",
            }),
            headers: {
              "x-api-key": `${config.newApiKey}`,
              "Content-Type": "application/json",
            },
          });
          const data = await res.json();
          if (data.status === "SUCCESS") {
            const updatedDraft = data.data.map((i) => {
              const isAddDiscount = i?.isAddDiscount;
              const products = i.items.map((j) => {
                const isTax = i?.isTax;
                const isItemDiscount = i?.isDiscount;

                const productFromList = productList.find(
                  (product) => product.productId === j.productId
                );
                if (productFromList) {
                  const product = getTaxableValueAndTaxs(
                    productFromList,
                    productFromList.productPrice,
                    j.count,
                    isItemDiscount,
                    isTax
                  );
                  return product;
                }
                return null;
              });
              const filteredProduct = products.filter((i) => i);
              let totalAmount = filteredProduct.reduce(
                (a, c) => a + c.itemTotal,
                0
              );
              console.log("isAddDiscount", isAddDiscount);
              if (isAddDiscount) {
                if (i.footerData?.discountType === "flat") {
                  totalAmount = totalAmount - i.footerData?.discount;
                } else if (i.footerData?.discountType === "percentage") {
                  totalAmount =
                    totalAmount - totalAmount * (i.footerData?.discount / 100);
                  console.log("totalAmount999", totalAmount);
                }
              }
              console.log("totalAmount0000", totalAmount);
              return {
                ...i,
                totalAmount: totalAmount,
                items: filteredProduct,
              };
            });
            setDraftBill(updatedDraft);
          }
        } catch (error) {
          console.log("getRestaurantDraftError", error);
        }
      };
      getDraft();
    })(shopId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopId, employeeId]);

  // const addToDraft = async (payload, actionKey) => {
  //   try {
  //     const response = await fetch(`${config.ApiGateway1}/draft/draft`, {
  //       method: "POST",
  //       body: JSON.stringify({
  //         action: actionKey,
  //         ...payload,
  //         employeeId: employeeId,
  //       }),
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     });
  //     const data = await response.json();
  //     if (data.status === "SUCCESS") {
  //       setDraftBillCatch((prev) => {
  //         return prev.filter((draft) => draft.billId !== payload.billId);
  //       });
  //       console.log("Successfully added to draft");
  //     }
  //   } catch (error) {
  //     console.log("addToDraftError", error);
  //   } finally {
  //   }
  // };

  return (
    <DraftContext.Provider value={value} {...props}>
      {children}
    </DraftContext.Provider>
  );
};

export default DraftProvider;

export const useKotDraft = () => {
  const context = React.useContext(DraftContext);
  if (context === undefined) {
    throw new Error(`useKotDraft must be used within a DraftProvider`);
  }
  return context;
};

export const useKotDraftWithCatch = () => {
  const context = React.useContext(DraftContext);
  if (context === undefined) {
    throw new Error(`useKotDraftB2b must be used within a DraftProvider`);
  }
  return [context[2], context[3]];
};
